<template>
  <div>
    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <h1>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">我的帐户</font>
            </font>
          </h1>
          <p>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">您可以在下面管理和更新您的详细信息。</font>
            </font>
          </p>
        </div>
      </div>
    </div>

    <!-- Main content area start here -->
    <section class="innerPage myaccount">
      <div class="container">
        <div class="breadcrumbWrap">
          <div class="breadcrumb">
            <!-- Breadcrumb NavXT 6.2.0 -->
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">我的资料</span>
              <meta property="position" content="2">
            </span>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="ziliao" style="width:67%;float:left;margin-top: 10px;">
          <h4 style="font-size:40px;margin-top: 10px;">我的资料</h4>
          <p style="border-bottom:1px solid #cccccc">您可以查看您的账号信息以及您的会员等级</p>
          <p>昵称：{{ info.nickname }}</p>
          <p>邮箱：{{ info.email }}</p>
          <p>电话：{{ info.mobile }}</p>
          <p>等级：{{ info.level }}</p>
          <p v-if="info.level!='普通会员'">有效期：{{ info.startTime }} ~ {{ info.endTime }}</p>
        </div>
        <div class="rightCol">
          <div class="myAccountmenu">
            <h4>
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">我的帐户</font>
              </font>
              <span></span>
            </h4>
            <ul id="menu-my-account" class>
              <li
                id="menu-item-332"
                class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-305 current_page_item menu-item-332"
              >
                <a href="#/Myprofile">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">我的资料</font>
                  </font>
                </a>
              </li>
              <li
                id="menu-item-333"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-350"
              >
                <a href="#/Mybookmarks">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">我的书签</font>
                  </font>
                </a>
              </li>
              <li
                id="menu-item-350"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-350"
              >
                <a href="#/Myvisit">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">我的浏览历史</font>
                  </font>
                </a>
              </li>
              <li
                id="menu-item-974"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-974"
              >
                <a href="#/Subscribe">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">管理订阅</font>
                  </font>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import ajax from '../ajax';
  export default {
    data(){
      return {
        info:{},
        id: 4
      }
    },
    created(){
      this.getInfo()
    },
    methods:{
      getInfo(){
        ajax.getUserInfo(
          this.$store.state.userdata.userId
        ).then(res=>{
          if(res.success){
            console.log(res.data)
            this.info=res.data
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Myprofile.vue